/* eslint-disable max-len */
import React from 'react';

interface Props extends React.SVGProps<SVGSVGElement> {
  color?: string;
}

const AcquisitionMonitor: React.FC<Props> = ({ color = '#000000', ...props }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 12.4755H6.39445C7.1804 12.4755 7.57337 12.4755 7.90501 12.653C8.23665 12.8305 8.45463 13.1574 8.8906 13.8114L9.05039 14.0511C9.47306 14.6851 9.68439 15.0021 9.97087 14.9851C10.2573 14.968 10.4297 14.6283 10.7743 13.9487L12.7404 10.072C13.0987 9.36537 13.2779 9.01206 13.5711 9.0003C13.8642 8.98853 14.0711 9.32635 14.485 10.002L15.1222 11.0424C15.5512 11.7427 15.7656 12.0928 16.1072 12.2842C16.4487 12.4755 16.8593 12.4755 17.6805 12.4755H19"
      stroke={props.style?.color || color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z"
      stroke={props.style?.color || color}
      strokeWidth="1.5"
    />
  </svg>
);

export default AcquisitionMonitor;
